export default __webpack_public_path__ + "courier.f142f84c.svg";